/*@flow*/
import curry from 'ramda/src/curry';
import reduce from 'ramda/src/reduce';
import assoc from 'ramda/src/assoc';
import keys from 'ramda/src/keys';

type KeyMap = { [key: string]: any };

export default (curry((keysMap: KeyMap, obj: KeyMap) =>
  reduce((acc, key) => assoc(keysMap[key] || key, obj[key], acc), {}, keys(obj))
): any);
